//  export const SERVER_URL = "http://localhost:5000/"
export const SERVER_URL = process.env.REACT_APP_BASE_URL;
